<template>
  <div class="modal-body align-center ">
    <b-icon icon="x-circle-fill" class="color-red" style="width: 26px; height: 26px"></b-icon>
    <div class="w-100 d-flex justify-content-center mt-2 content-modal">
      <div v-if="type === 'err_auth'" style="width: 332px">
        <span>Có lỗi xảy ra trong quá trình <span class="text-blue">xác thực tài khoản</span>. Vui lòng đăng nhập lại!</span>
      </div>
      <div v-if="type === 'log_out'" style="width: 362px">
        <span>Tài khoản của bạn đã đăng xuất hoặc <span class="text-blue">không có quyền truy cập</span> vào trang này.</span>
        <span>Vui lòng đăng nhập lại!</span>
      </div>
    </div>
    <div class="line"></div>
    <b-button variant="primary" :class="type === 'err_auth' ? 'mt-3' : 'mt-2'" @click="handleButton">Đăng nhập lại</b-button>
  </div>
</template>

<script>
export default {
  name: "NotiAuthModal",
  props: ['type'], //err_auth, log_out
  methods : {
    handleButton(){
      location.href = "https://salework.net/login?target=chat";
    }
  }
}
</script>

<style scoped>
.modal-body{
  width: 480px;
  height: 220px;
}

.color-red{
  color: #CF4547;
}

.text-blue{
  font-weight: 700;
  color: #327AE7;
}

.content-modal{
  font-size: 16px;
}

.line {
  width: 332px;
  border-top: #ECECEC 1px solid;
  margin-left: 54px;
  margin-top: 20px;
}
</style>